export default "__VITE_ASSET__1a58bbb0__"